import { css } from 'styled-components'

/**
 * Positioning wrapper for the transactions/accounting date filter inside the
 * data-grid toolbar dropdown. The menu chrome (rows, calendar, reset) lives in
 * the shared DateRangePresetMenu component.
 */
export default css`
  &.DateFilterDropdown {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0px;
    z-index: 5;
    padding-bottom: 10px;
  }
`
